import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Building, Clock, CreditCard, Users, X } from 'lucide-react';

const PaymentDialog = ({
  open,
  onOpenChange,
  orderType,
  selectedCreditCustomer,
  onClearCreditCustomer,
  onPlaceOrder,
  onOpenCreditCustomerSelect,
  calculateSubtotal,
  calculateDiscount,
  calculateTax,
  calculateTotal
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Payment</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <Card className="bg-muted">
            <CardContent className="p-4 space-y-2">
              <div className="flex justify-between"><span>Subtotal</span><span>₹{calculateSubtotal().toFixed(2)}</span></div>
              <div className="flex justify-between text-red-600"><span>Discount</span><span>-₹{calculateDiscount().toFixed(2)}</span></div>
              <div className="flex justify-between"><span>Tax (18%)</span><span>₹{calculateTax().toFixed(2)}</span></div>
              <div className="flex justify-between font-bold text-xl border-t pt-2"><span>Total</span><span>₹{calculateTotal().toFixed(2)}</span></div>
            </CardContent>
          </Card>

          {/* Credit Customer Selection */}
          {selectedCreditCustomer && (
            <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Users className="w-4 h-4 text-blue-600" />
                <div>
                  <p className="font-medium text-sm">{selectedCreditCustomer.name}</p>
                  <p className="text-xs text-gray-500">{selectedCreditCustomer.phone}</p>
                </div>
              </div>
              <Button variant="ghost" size="sm" onClick={onClearCreditCustomer}>
                <X className="w-4 h-4" />
              </Button>
            </div>
          )}

          {orderType === 'room_service' ? (
            <div className="space-y-3">
              <Label>Payment Option</Label>
              <Button variant="outline" className="w-full h-14 justify-start" onClick={() => onPlaceOrder(true, 'room_bill', 'posted_to_room')}>
                <Building className="h-5 w-5 mr-3" />
                <div className="text-left">
                  <p className="font-medium">Post to Room Bill</p>
                  <p className="text-xs text-muted-foreground">Add to guest folio</p>
                </div>
              </Button>
              <Button variant="outline" className="w-full h-14 justify-start" onClick={() => onPlaceOrder(true, 'pending', 'pending_collection')}>
                <Clock className="h-5 w-5 mr-3" />
                <div className="text-left">
                  <p className="font-medium">Collect at Room</p>
                  <p className="text-xs text-muted-foreground">Payment pending</p>
                </div>
              </Button>
              <div className="border-t pt-3">
                <p className="text-sm text-muted-foreground mb-2">Or pay now:</p>
                <div className="grid grid-cols-3 gap-2">
                  <Button variant="outline" onClick={() => onPlaceOrder(true, 'cash', 'paid')}>💵 Cash</Button>
                  <Button variant="outline" onClick={() => onPlaceOrder(true, 'card', 'paid')}>💳 Card</Button>
                  <Button variant="outline" onClick={() => onPlaceOrder(true, 'upi', 'paid')}>📱 UPI</Button>
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-3">
              <Label>Payment Method</Label>
              <div className="grid grid-cols-2 gap-2">
                <Button variant="outline" className="h-16 flex-col" onClick={() => onPlaceOrder(true, 'cash', 'paid')} data-testid="pay-cash-btn">
                  <span className="text-2xl mb-1">💵</span><span className="text-xs">Cash</span>
                </Button>
                <Button variant="outline" className="h-16 flex-col" onClick={() => onPlaceOrder(true, 'card', 'paid')} data-testid="pay-card-btn">
                  <span className="text-2xl mb-1">💳</span><span className="text-xs">Card</span>
                </Button>
                <Button variant="outline" className="h-16 flex-col" onClick={() => onPlaceOrder(true, 'upi', 'paid')} data-testid="pay-upi-btn">
                  <span className="text-2xl mb-1">📱</span><span className="text-xs">UPI</span>
                </Button>
                <Button 
                  variant="outline" 
                  className="h-16 flex-col bg-amber-50 border-amber-200 hover:bg-amber-100" 
                  onClick={onOpenCreditCustomerSelect}
                  data-testid="pay-credit-btn"
                >
                  <CreditCard className="w-6 h-6 mb-1 text-amber-600" />
                  <span className="text-xs text-amber-700">Credit</span>
                </Button>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
